import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpErrorResponse
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError, from } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { PostDataService } from './post-data.service'; // adjust path

@Injectable()
export class InterceptorService implements HttpInterceptor {

  constructor(private postDataService: PostDataService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = localStorage.getItem('loginToken')?.replace(/^"|"$/g, '');
    // const token = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6NjMsInVzZXJOYW1lIjoiZWFzaHdhcjU2ODJAZ21haWwuY29tIiwiZW1haWwiOiJlYXNod2FyNTY4MkBnbWFpbC5jb20iLCJmaXJzdE5hbWUiOiJFYXNod2FyIiwibGFzdE5hbWUiOiJJeWVyIiwicGhvbmUiOiJlYXNod2FyNTY4MkBnbWFpbC5jb20iLCJzdXBwbGllcklkIjoxNCwic3VwcGxpZXJBZ2VudElkIjo0MTkyLCJhZ2VudENvbnRhY3RJZCI6Mzg3MiwiY291bnRyeSI6IkluZGlhICjgpK3gpL7gpLDgpKQpIiwiY291bnRyeUNvZGUiOiI5MSIsImlhdCI6MTc1MjEzNzAxNCwiZXhwIjoxNzUyMTM3MDc0fQ.BrPtE14imOGrUN5TkbRCh9WYnibYKKQQ4ikh7hGIi1Y";


    let authReq = req;
    if (token) {
      authReq = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });
    }

    return next.handle(authReq).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          // Token expired — try refreshing it
          return from(this.postDataService.postGetValidToken()).pipe(
            switchMap(() => {
              const newToken = localStorage.getItem('loginToken')?.replace(/^"|"$/g, '');
              const retryReq = req.clone({
                setHeaders: {
                  Authorization: `Bearer ${newToken}`
                }
              });
              return next.handle(retryReq);
            }),
            catchError((err) => {
              // Even refresh token failed
              return throwError(() => err);
            })
          );
        } else {
          return throwError(() => error);
        }
      })
    );
  }
}
